module.exports = __webpack_public_path__ + "static/img/rotation-chart1.1c1b1768.jpeg";